module.exports = __webpack_public_path__ + "img/logo.0a8a4ad4.png";